import { lazy } from "react";

export const LazySearchPageFooterBase = lazy(() =>
  import(
    /* webpackChunkName: "search-page-footer" */ "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageFooter/__internal__/SearchPageFooterBase"
  ).then((m) => ({
    default: m.SearchPageFooterBase,
  }))
);
